const checkPermission = (module,action)=>{
    let result = {status:false,redirect_url:''};
    switch(module){
        case 'Birthday':
            switch(action){
                case 'view':
                    let urserHasPermission = checkInPermission('3180','IsViewPermission');
                    if(urserHasPermission){
                        result.status=true
                    }else{
                        result.status=false;
                        let user = getUserDetails();
                        result.redirect_url = '/50881180195049806954114046419509/'+user.DefaultContactID+'/'+user.Name;
                    }
                 break;   
            }
        break;
    }
    return result;
}

const checkInPermission = (ObjectType,action)=>{
    let permission_array = JSON.parse(localStorage.getItem('permission'));
    let findRecord = permission_array.find(o=>o.ObjectType==ObjectType);
    let permission = findRecord?.[action]?true:false;
    return permission;

}
const getUserDetails = ()=>{
    return JSON.parse(localStorage.getItem('user'));
}
export default checkPermission;